import { APIPersonalAutoApplicationFormDriver } from 'types/api.types';
import { BinderSectionData } from '../hooks/useBinderSectionData';
import { processValidation, validateFailedObjects } from '../utils/helpers';

export const processGapInInsuranceImmediatelyPriorData = (
  drivers: APIPersonalAutoApplicationFormDriver[],
  remarks: Remark[],
  validation?: Validation,
): BinderSectionData => {
  const validationData = processValidation(validation);

  const processedDrivers = drivers.map((driver, index) => ({
    name: driver.name,
    remarks: remarks.find((r) => r.item_key === `driver-${index + 1}`)?.text,
    isValid: validateFailedObjects(index, validation),
  }));

  return {
    title: 'Gap in Insurance Immediately Prior',
    description: '',
    isValid: validationData.isValid,
    message: validationData.message,
    data: {
      drivers: processedDrivers,
    },
  };
};
